import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_ADDRESSLIST: gql`
        query getAddress($eirCode: String!) {
            addressList(eirCode: $eirCode) {
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                }
            }
        }
    `,

    SUBMIT_SIM_REPLACEMENT: gql`
        mutation simReplacement($request: PublicSimOrderRequest!) {
            orderSim(request: $request)
        }
    `,

    GET_SIM_ELIGIBILITY_CHECK: gql`
        query getSimSwapRequests($serviceId: Int!) {
            getSimSwapRequests(serviceId: $serviceId) {
                serviceId
                waived
                barServices
                iccid
                imsi
                status
                type
                simSwapAddonCode
                charges {
                    catalogChargeCode
                    catalogPricePlanCode
                    description
                    billingType
                    defaultPriceVatIncluded
                }
                firstName
                lastName
                email
                phoneNumber
                appliedFees
                updatedAt
                createdAt
                address {
                    addressLine1
                    addressLine2
                    town
                    county
                    code
                }
            }
        }
    `,

    SIM_ACTIVATE: gql`
        mutation activateSim($activateSim: ActivateSimRequest!) {
            activateSim(activateSim: $activateSim)
        }
    `,

    GET_SIM_CHARGES: gql`
        query getSimSwapCharges($serviceId: Int!) {
            getSimSwapCharges(serviceId: $serviceId) {
                charges {
                    billingType
                    catalogChargeCode
                    catalogPricePlanCode
                    defaultPriceVatIncluded
                    description
                }
                onGoingRequest
            }
        }
    `,
    GET_ESIM_INFORMATION: gql`
        query getESIMInformation($serviceId: Int!) {
            getESIMInformation(serviceId: $serviceId) {
                activationQrCode
                activationQrCodeFormat
                esimPassCode
                esimStatus
            }
        }
    `,
    ESIM_SWAP: gql`
        mutation esimSwap($serviceId: Int!) {
            esimSwap(serviceId: $serviceId)
        }
    `,
};

export const getAddressList = async ({ graphql, eirCode }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_ADDRESSLIST,
            variables: {
                eirCode: eirCode,
            },
        });

        return data.addressList.addresses;
    } catch (error) {
        throw new Error(error);
    }
};

export const submitSimReplacement = async ({ graphql, request }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.SUBMIT_SIM_REPLACEMENT,
            variables: {
                request,
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const getSimEligibilityCheck = async ({ graphql, serviceId }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_SIM_ELIGIBILITY_CHECK,
            variables: {
                serviceId: serviceId,
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const activateSimAPI = async ({ token, graphql, activateSim }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.SIM_ACTIVATE,
            variables: {
                activateSim,
            },
        });
        return data.activateSim;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getSimCardCharges = async ({ graphql, token, serviceId }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_SIM_CHARGES,
            variables: {
                serviceId: serviceId,
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const getESIMInformation = async ({ graphql, serviceId }) => {
    try {
        const { data, errors } = await graphql.query({
            query: ENDPOINT.GET_ESIM_INFORMATION,
            variables: {
                serviceId: serviceId,
            },
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const esimSwap = async ({ graphql, serviceId }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.ESIM_SWAP,
            variables: {
                serviceId: serviceId,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
